(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
(function () {
  var toggle = document.querySelector('.cart-order-note__toggle');
  var field  = document.getElementById('cart-order-note-field');
  var input  = document.getElementById('cart-note');
  var hint   = document.querySelector('.cart-order-note__hint');
  if (!toggle || !field || !input) return;

  var defaultHint = hint ? hint.textContent : '';

  // If a note already exists, expand on load so customer can see it.
  if (input.value.trim().length > 0) {
    field.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    field.hidden = expanded;
    if (!expanded) {
      setTimeout(function () { input.focus(); }, 50);
    }
  });

  var lastSaved = input.value;
  var saveTimer = null;

  function setHint(text, state) {
    if (!hint) return;
    hint.textContent = text;
    hint.classList.remove('is-saving', 'is-saved');
    if (state) hint.classList.add(state);
  }

  function saveNote() {
    var value = input.value;
    if (value === lastSaved) return;
    setHint('Saving…', 'is-saving');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: value })
    }).then(function (r) {
      if (!r.ok) throw new Error('save failed');
      lastSaved = value;
      setHint('Note saved', 'is-saved');
      setTimeout(function () { setHint(defaultHint); }, 2000);
    }).catch(function () {
      setHint('Could not save note — it will still be sent when you check out.');
    });
  }

  input.addEventListener('blur', saveNote);
  input.addEventListener('input', function () {
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(saveNote, 1200);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-promo"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Find the button in this section
  const trigger = document.querySelector('.signup-promo-wrapper .signup-promo-klaviyo-trigger');
  
  // Debug: Check if the button is found
  if (!trigger) {
    console.error('Signup promo button not found. Selector: .signup-promo-wrapper .signup-promo-klaviyo-trigger');
    return;
  }
  
  // Debug: Confirm the script is running
  console.log('Signup promo script loaded, button found:', trigger);

  // Add click event listener
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    console.log('Signup promo button clicked, triggering Klaviyo form UuMf2F');
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UuMf2F']);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
